export default "/assets/images/clean-like-boss.d873de804dbf64a9.webp";